<template>
  <div class="spo-card pa-2 rounded my-2" v-if="!masquer_activite">

    <v-row>
      <v-col>
        <div class="text-h5 font-weight-bold">{{ activite.nom }}</div>
        <div v-if="activite.get_metadata('infos_supp')" v-html="activite.get_metadata('infos_supp')"></div>
        <div v-if="activite.quantite != '0'">{{ infos_quantite_restante }}</div>
        <div v-else>{{ activite.nb_inscrits }} inscrits</div>

        <div v-if="$moment(activite.date_min).isValid()">Ouverture des inscriptions le {{
          $moment(activite.date_min).format("DD/MM/YYYY à HH:mm") }}</div>
        <div v-if="$moment(activite.date_max).isValid()">Fermeture des inscriptions le {{
          $moment(activite.date_max).format("DD/MM/YYYY") }}</div>
      </v-col>
      <v-col cols="12" lg="3" xl="2">
        <div v-if="mainStore.billetterie_mode">
          <SportipsButton v-if="show_inscription_button" @onClick="$router.push({ name: 'Inscriptions' })"
            icon="mdi-pencil-plus-outline" chevron action-button full-width>Réserver</SportipsButton>
          <div v-else
            class="d-flex align-center justify-center ga-1 bg-dark-red text-white rounded py-2 px-1 font-weight-600 cursor-disabled">
            <v-icon icon="mdi-pencil-off-outline"></v-icon>
            Inscriptions closes
          </div>
        </div>
        <div class="text-h6 mt-3 font-weight-bold d-flex flex-column align-md-end align-center">
          <span v-if="parseInt(activite.prix) > 0">{{ activite.prix }}€</span><span v-else>Gratuit</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: ["activite", "all_activites"],
  computed: {

    ...mapStores(useMainStore),
    masquer_activite() {
      const masquer_activite = this.activite.get_metadata("masquer_activite");
      if (masquer_activite && masquer_activite == "1") {
        return true;
      }
      if (!this.activite.visible_accueil) {
        return true;
      }
      return false;
    },
    infos_quantite_restante() {
      let quantite = this.activite.get_quantite_restante(this.all_activites);
      const masquer_places_restantes = this.activite.get_metadata("masquer_places_restantes");
      if (masquer_places_restantes && masquer_places_restantes == "1") {
        return "";
      }
      if (quantite == -1) {
        return "";
      }
      if (quantite == 0) {
        return "Complet";
      }
      return quantite + " places restantes";
    },
    show_inscription_button() {
      return this.activite.is_selectionnable(this.mainStore.module.status, this.mainStore.view_as_admin, this.mainStore.inscription_as_admin, this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
    },
  },
};
</script>

<style lang="scss" scoped></style>